import {createRouter, createWebHistory} from "vue-router";
import { ref } from 'vue';
import Home from "./Home.vue";
import Character from "./Character.vue";
import helpers from '../util/helpers';

let router;

if(window.location.pathname === '/steal-estate/' || window.location.pathname.search('steal-estate/character') > 0) {
  router = createRouter({
    history: createWebHistory('/steal-estate/'),
    routes: [
      {
        path: '/',
        name:'home',
        component: Home,
      },
      {
        path: '/character/:name',
        name:'character',
        component: Character,
        props: true,
      },
    ]
  });
}

router.beforeEach(to => {
  to.meta.intro = !helpers.isIntroSeen();
  window.app.config.globalProperties.$tutorial = ref(!to.meta.intro);
  window.app.config.globalProperties.$audioUrl = ref('');
  return true;
});
router.afterEach(to => {
	window.timers.forEach((timeoutId, i) => {
		console.log('clear timeout', timeoutId);
		window.clearTimeout(timeoutId);
		window.timers.splice(i, 1);
	});
	setTimeout(() => {
		helpers.enableScrolling();
	}, 1000);

});
export default router;
